import { render, staticRenderFns } from "./SuccessResult.vue?vue&type=template&id=6e2a9cd0&scoped=true"
import script from "./SuccessResult.vue?vue&type=script&lang=js"
export * from "./SuccessResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2a9cd0",
  null
  
)

export default component.exports